module.exports = __webpack_public_path__ + "assets/images/HVAR_150.png";